module.exports = __webpack_public_path__ + "img/panels_parallel02.28cb6e17.gif";